import useRequest from '@hooks/useRequest';
import { IAtividade } from '@model/Atividade';
import React from 'react';

const controller = "/Atividade";

export function useAtividadeService () {
    const _request = useRequest();

    const load = React.useCallback((entidade: string, chaves: string) => {
        return _request.get<IAtividade[]>(`${controller}/Load/${entidade}`, {
            params: {
                chaves
            }
        })
    }, [_request]);

    return React.useMemo(() => ({
        load
    }), [load]);
}